import React, { useContext } from "react";
import { ProjectContext, Sds, ConfigContext } from "@swegon/sds-core";
import { init as initApm } from "@elastic/apm-rum";

export const SdsWrapper = ({ children }) => {
    const { project } = useContext(ProjectContext);
    const { config } = useContext(ConfigContext);

    const getEnvironmentForElastic = () => {
        const lowerCaseEnv = config.environment.toLowerCase();
        if(process.env.NODE_ENV === "development") return process.env.NODE_ENV;
    
        if(lowerCaseEnv === "uat") return "test";
    
        return lowerCaseEnv;
    }

    initApm({
        serviceName: "sdsapplication",
        serverUrl: "https://7a989ebebfd04f1f849e92876ed1453e.apm.eu-west-1.aws.cloud.es.io:443",
        breakdownMetrics: true,
        environment: getEnvironmentForElastic(),
        distributedTracingOrigins: [
            config.sds_application
        ],
        centralConfig: true,
    });

    return (
        <Sds items={[]} name={project ? project.Name : ""} useSdsPrint={false}>
            {children}
        </Sds>
    );
};
export default SdsWrapper;
